<template>
  <v-container style="margin-top: -100px;">
    <!-- <v-row align="center" class="row--35"> -->
    <v-row class="row--35">
      <!-- <v-col class="d-md-none" lg="4" md="4" cols="12">
        <div style="margin-top: -35%;">
          <slot name="thum-img"></slot>
        </div>
      </v-col> -->
      <v-col lg="9" md="9" cols="12">
        <div class="about-inner inner">
          <v-row class="mt--80">
            <v-col sm="12" cols="12">
              <h3 class="heading-title colorSilver">ΝΟΣΗΛΕΙΑ</h3>

              <!-- <h3 class="heading-title">Έκπτωση 15%</h3> -->
              <p
                style="font-size: 24px; margin-top: -10px;margin-bottom: 10px;"
                class="regularStyle"
              >
                Έκπτωση 15%
              </p>
              <h3
                class="heading-title heading-title-new"
                style="font-size: 20px;line-height: 1.5;"
              >
                Δυνατότητα πληρωμής σε άτοκες δόσεις
              </h3>
              <p style="font-size: 16px;">
                Η έκπτωση γίνεται επί του ιδιωτικού τιμοκαταλόγου. Της έκπτωσης
                εξαιρούνται υλικά, ειδικά υλικά, φάρμακα, αμοιβές ιατρών.
                Εξαιρούνται των εκπτώσεων άγονες, μοριακές εξετάσεις.
              </p>
            </v-col>
          </v-row>
          <hr class=" new3 mt--30 mt_sm-20">

          <v-row class="mt--50 mt_sm--30">
            <v-col sm="12" cols="12">
              <h3 class="heading-title colorSilver">ΜΕΤΑΦΟΡΑ</h3>
              <p
                style="font-size: 24px;    margin-top: -10px;margin-bottom: 5px;"
                class="regularStyle"
              >
                Δωρεάν μεταφορά
              </p>
              <ul>
                <li>με ασθενοφόρο σε περίπτωση νοσηλείας εντός Αττικής</li>
                <li>
                  δωρεάν διακομιδή εισαγωγής από Healthspot σε Κλινική HHG
                </li>
                <li>
                  15% έκπτωση σε διακομιδή για εξέταση από τα διαγνωστικά κέντρα
                  Healthspot σε Κλινική HHG.
                </li>
              </ul>
            </v-col>
          </v-row>
          <hr class=" new3 mt--30 mt_sm-20">

          <v-row class="mt--50 mt_sm--20">
            <v-col sm="12" cols="12">
              <h3 class="heading-title colorSilver">ΕΞΤΡΑ ΠΑΡΟΧΕΣ</h3>
              <p
                style="font-size: 24px;    margin-top: -10px;margin-bottom: 5px;"
                class="regularStyle"
              >
                Digital Clinic App
              </p>
              <p>
                Ψηφιακή υπηρεσία τηλεϊατρικής: Χωρίς αναμονή και χωρίς
                μετακίνηση, η εφαρμογή προσφέρει στον ασθενή ιατρική εκτίμηση,
                διάγνωση και ιατρικές οδηγίες μέσω chat. Με την ασημένια κάρτα
                έχετε μία δωρεάν συνεδρία στο Digital Clinic.
              </p>
            </v-col>
          </v-row>
          <hr class=" new3 mt--30 mt_sm-20">

          <v-row class="mt--30  ">
            <v-img
              max-height="60"
              max-width="60"
              style="margin-left: 12px;"
              class="mb--10"
              src="../../assets/images/pronomia/pregnancy2.png"
            ></v-img>
          </v-row>
          <v-row>
            <v-col sm="12" cols="12">
              <h3 class="heading-title colorSilver">ΕΓΚΥΜΟΣΥΝΗ & ΤΟΚΕΤΌΣ</h3>
              <p
                style="font-size: 24px;    margin-top: -10px;margin-bottom: 5px;"
                class="regularStyle"
              >
                Πακέτα τοκετού και προγεννητικού ελέγχου
              </p>
              <p style="font-size: 16px; line-height: 1.5;">
                Ενημερωθείτε για τα προνομιακά πακέτα τοκετού και προγεννητικού
                ελέγχου στη Μαιευτική Γυναικολογική Κλινική Μητέρα στα τηλέφωνα:
                210 68 69 000 & 210 68 69 274
              </p>
            </v-col>
          </v-row>
          <hr class=" new3 mt--30 mt_sm-20">

          <v-row class="mt--30  ">
            <v-img
              max-height="60"
              max-width="60"
              style="margin-left: 12px;"
              class="mb--10"
              src="../../assets/images/pronomia/exetaseis2.png"
            ></v-img>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="d-sm-flex">
                <div class="p-6">
                  <h3 class="heading-title colorSilver mt_sm--0">
                    ΔΙΑΓΝΩΣΤΙΚΕΣ ΕΞΕΤΑΣΕΙΣ
                  </h3>
                </div>
                <div class="p-6">
                  <p
                    style="font-size: 13px; line-height: 1.5; color: #777978"
                    class="mb_sm--20 mb_md--20 ml--10 ml_sm--0"
                  >
                    (Υγεία, Μetropolitan Hospital, Μητέρα, <br />
                    Metropolitan General, Λητώ, Creta Interclinic)
                  </p>
                </div>
              </div>
              <ul>
                <li class="mt--5">
                  Ευνοϊκή τιμολογιακή πολιτική στις διαγνωστικές και
                  εργαστηριακές εξετάσεις στα εξωτερικά ιατρεία και στα τμήματα
                  επειγόντων περιστατικών των θεραπευτηρίων: παρέχεται η τιμή
                  κρατικού τιμοκαταλόγου +30 % (ΦΕΚ+30%)
                </li>
                <li class="mt--5">
                  Σε Μαγνητικές Τομογραφίες (MRI), Αξονικές Τομογραφίες (CT) και
                  Triplex Καρδιάς και Σώματος παρέχεται τιμή κρατικού
                  τιμοκαταλόγου (ΦΕΚ)
                </li>
                <li class="mt--5">
                  Στις εξετάσεις Μοριακής Βιολογίας καθώς και σε ειδικές
                  Αξονικές και Μαγνητικές Τομογραφίες (π.χ. Αξονική
                  Στεφανιογραφία, Μαγνητική Τομογραφία Καρδιάς, Μαγνητική
                  Μαστών, Φασματοσκοπία κτλ.) έκπτωση 20% επί του ιδιωτικού
                  τιμοκαταλόγου
                </li>
              </ul>
              <v-col class="d-block d-sm-none" cols="12">
                <img
                  max-height="150"
                  style="margin-left: -18px;"
                  src="../../assets/images/pronomia/health.png"
                />
              </v-col>
              <h3 class="heading-title heading-title-new" style="font-size: 20px">
                Διαγνωστικά Κέντρα ΗealthSpot
              </h3>
              <ul>
                <li>
                  Δωρεάν συνταγογράφηση διαγνωστικών εξετάσεων όταν
                  πραγματοποιούνται στα διαγνωστικά κέντρα HealthSpot
                </li>
                <li class="mt--5">
                  Τιμές ΦΕΚ σε αιματολογικές εξετάσεις χωρίς χρήση παραπεμπτικού
                  ΕΟΠΥΥ
                </li>
                <li class="mt--5">
                  Μοριακός έλεγχος για την ανίχνευση του Sars-Cov-2 (Covid-19)-
                  45€
                </li>
                <li class="mt--5">
                  20% έκπτωση επί του ιδιωτικού τιμοκαταλόγου στις ακτινογραφίες
                  (χωρίς χρήση παραπεμπτικού ΕΟΠΥΥ)
                </li>
                <li class="mt--5">
                  15% έκπτωση επί του ιδιωτικού τιμοκαταλόγου στους υπερήχους
                  (χωρίς χρήση παραπεμπτικού ΕΟΠΥΥ)
                </li>
                <li class="mt--5">
                  15% έκπτωση στην συμμετοχή του ασφαλισμένου για χρήση
                  παραπεμπτικού ΕΟΠΥΥ
                </li>
              </ul>
            </v-col>
          </v-row>
          <hr class=" new3 mt--30 mt_sm-20">

          <v-row class="mt--20  ">
            <v-img
              max-height="60"
              max-width="60"
              style="margin-left: 12px;"
              class="mb--10"
              src="../../assets/images/pronomia/docare2.png"
            ></v-img>
          </v-row>
          <v-row>
            <v-col sm="12" cols="12">
              <div class="d-flex">
                <div class="p-6">
                  <h3 class="heading-title colorSilver">
                    DOCARE ΠΑΡΟΧΕΣ
                  </h3>
                </div>
                <div class="p-6">
                  <p
                    style="font-size: 13px; line-height: 1.5; color: #777978"
                    class="mt--5 ml--10"
                  >
                    (Μητέρα)
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-row>
                <v-col lg="12" md="12" sm="12" cols="12">
                  <h3 class="heading-title heading-title-new" style="font-size: 20px">
                    Υπηρεσίες αδυνατίσματος
                  </h3>
                  <ul>
                    <li>
                      Πρόγραμμα αδυνατίσματος & σμίλευσης σώματος<span
                        class="colorSilver"
                      >
                        με 55 € η συνεδρία</span
                      >
                    </li>
                    <li>
                      Πρόγραμμα για τοπικό πάχος & μείωση πόντων
                      <span class="colorSilver">με 65 € η συνεδρία</span>
                    </li>
                  </ul>
                  <h3 class="heading-title heading-title-new" style="font-size: 20px">
                    Υπηρεσίες ομορφιάς
                  </h3>
                  <ul>
                    <li>
                      Μεσοθεραπεία προσώπου
                      <span class="colorSilver"> με 80 €</span>
                    </li>
                    <li>
                      Πρόγραμμα Laser αποτρίχωση Full Body
                      <span class="colorSilver">με 175€ η συνεδρία</span>
                    </li>
                  </ul>
                  <!-- <span class="freeTicket mt--20"> ΔΩΡΕΑΝ </span> -->
                </v-col>
              </v-row>

              <v-row class="mt--20">
                <v-col lg="12" md="12" sm="12" cols="12">
                  <span class="freeTicketText"> ΔΩΡΕΑΝ </span>
                </v-col>
              </v-row>
              <v-row class="mt--10">
                <v-col lg="12" md="12" sm="12" cols="12">
                  <h3 class="heading-title heading-title-new" style="font-size: 20px">
                    Μία θεραπεία ματιών Eye Lift
                  </h3>
                  <p>
                    H θεραπεία διαρκεί μία ώρα και μειώνει τις λεπτές ρυτίδες
                    γύρω από τα μάτια, αποσυμφορεί τα πρησμένα μάτια και σβήνει
                    τους μαύρους κύκλους.
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <hr class=" new3 mt--30 mt_sm-20">

          <v-row class="mt--60 mt_sm--30">
            <div class="d-sm-flex">
              <div class="p-6">
                <h3 class="heading-title colorSilver mt_sm--0 ml--15">
                  CHECK UP
                </h3>
              </div>
              <div class="p-6">
                <p
                  style="font-size: 13px; line-height: 1.5; color: #777978"
                  class="mb_sm--20 mb_md--20 ml--10 ml_sm--15"
                >
                  (Υγεία, Μetropolitan Hospital, Μητέρα, <br />
                  Metropolitan General, Λητώ, Creta Interclinic)
                </p>
              </div>
            </div>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="mt--20 mt_sm--0">
                <v-col
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="withoutBorder"
                  style="border-right: 1px dotted"
                >
                  <h3 class="heading-title" style="color:red; font-size: 20px">
                    Για τη γυναίκα
                  </h3>

                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Γυναικολογικός έλεγχος
                  </h3>
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    <span class="colorSilver"> • 30 €</span>
                  </h3>
                  <ul>
                    <li>
                      Εξετάσεις Αίματος: Γενική Αίματος, TSH, Σίδηρος, Φερριτίνη
                    </li>
                    <li>Γενική Ούρων</li>
                    <li>Τεστ ΠΑΠ</li>
                    <li>Βασική Γυναικολογική εξέταση</li>
                  </ul>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Ενδοκολπικό Υπερηχογράφημα
                    <span class="colorSilver"> • 20 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Υπέρηχος μαστού <span class="colorSilver"> • 25 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Μαστογραφία <span class="colorSilver"> • 40 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--0"
                    style="font-size: 20px"
                  >
                    Τομοσύνθεση <span class="colorSilver"> • 50 €</span>
                  </h3>
                  <p
                    style="font-size: 13px; line-height: 1.5; color: #777978"
                    class="mb_sm--20 mb_md--20 mt--5"
                  >
                    (Μetropolitan Hospital, & Metropolitan General)
                  </p>
                </v-col>
                <v-col
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="withoutBorder"
                  style="border-right: 1px dotted"
                >
                  <h3 class="heading-title" style="color:red; font-size: 20px">
                    Για τον άντρα
                  </h3>
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    <span class="colorSilver"> • 30 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Πρόγραμμα ελέγχου προστάτη
                  </h3>
                  <ul>
                    <li>P.S.A.</li>
                    <li>FREE P.S.A.</li>
                    <li>Κλινική εξέταση προστάτη</li>
                  </ul>
                </v-col>
                <v-col lg="4" md="4" sm="12" cols="12">
                  <h3 class="heading-title" style="color:red; font-size: 20px">
                    Για το παιδί
                  </h3>
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    <span class="colorSilver"> • 45 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Προληπτικός έλεγχος υγείας
                  </h3>
                  <ul>
                    <li>Γενική αίματος</li>
                    <li>Σάκχαρο</li>
                    <li>Κρεατινίνη</li>
                    <li>Ουρία</li>
                    <li>Τριγλυκερίδια</li>
                    <li>FT4</li>
                    <li>HDL χοληστερίνης</li>
                    <li>LDL χοληστερίνης</li>
                    <li>Χοληστερίνη αίματος</li>
                    <li>Φερριτίνη</li>
                    <li>Σίδηρος</li>
                    <li>Τ.Κ.Ε.</li>
                    <li>Παιδιατρική εξέταση</li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- <span class="freeTicket mt--40"> ΔΩΡΕΑΝ </span> -->
          <v-row class="mt--20">
            <v-col lg="12" md="12" sm="12" cols="12">
              <span class="freeTicketText"> ΔΩΡΕΑΝ </span>
            </v-col>
          </v-row>
          <v-row class="mb--60 mb_sm--10">
            <v-col lg="12" md="12" sm="12" cols="12">
              <h3 class="heading-title heading-title-new mt--10  mb--10" style="font-size: 20px">
                • Ένας αιματολογικός έλεγχος τον χρόνο σε όλα τα θεραπευτήρια
              </h3>
              <p>
                Περιλαμβάνει: Γενική Αίματος, Σάκχαρο, Ουρία, Κρεατινίνη,
                Χοληστερόλη,HDL, LDL, Τριγλυκερίδια, SGOT, SGPT, TSH, Γενική
                Ούρων.
              </p>
              <h3 class="heading-title heading-title-new mt--10  mb--10" style="font-size: 20px">
                • Ένας Βασικός αιματολογικός έλεγχος τον χρόνο στα διαγνωστικά
                κέντρα Healthspot:
              </h3>
              <p>
                Περιλαμβάνει: Γενική αίματος, Γενική Ούρων, Σάκχαρο, Ουρία,
                Χοληστερίνη.
              </p>
              <h3 class="heading-title heading-title-new mt--10  mb--10" style="font-size: 20px">
                • 10% έκπτωση
              </h3>
              <p>στα ειδικά check up στα διαγνωστικά κέντρα Healthspot.</p>
            </v-col>
          </v-row>
          <v-row class="mb_sm--60 d-block d-sm-none mt--50 mt_sm--10">
            <v-col lg="9" md="9" sm="12" cols="12">
              <h3
                class="heading-title heading-title-new mt--10  mb--10"
                style="font-size: 20px"
              >
                Καμπάνιες
              </h3>
              <p style="font-size: 16px">
                Μέσα απο την εφαρμογή θα ενημερώνεστε άμεσα για τις καμπάνιες μας για την πρόληψη υγείας σε εξαιρετικά προνομιακές τιμές.
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col class="mt--100 d-none d-md-block" lg="3" md="3" cols="12">
        <div>
          <slot name="thum-img"></slot>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style scoped>
.colorSilver {
  color: rgb(132, 135, 136);
  font-family: PFBagueSansPro-Bold;
  font-weight: bold;
}
th {
  font-size: 14px !important;
}
.freeTicket {
  background-color: rgb(132, 135, 136);
  position: absolute;
  margin-bottom: 20px;
  left: -23%;
  right: 71%;
  text-align: right;
  color: white;
  font-size: 25px;
  font-weight: bold;
  border-top-right-radius: 25px 22px;
  border-bottom-right-radius: 25px 22px;
  padding-right: 20px;
}

.freeTicketText {
  color: red;
  font-size: 22px;
  font-family: "PFBagueSansPro-Bold";
  font-weight: bold;
}

.freeTicketRight {
  background-color: rgb(132, 135, 136);
  position: absolute;
  margin-bottom: 20px;
  left: 0%;
  right: 58%;
  text-align: right;
  color: white;
  font-size: 25px;
  font-weight: bold;
  border-top-right-radius: 25px 22px;
  border-bottom-right-radius: 25px 22px;
  padding-right: 20px;
}
h3 {
  font-family: "PFBagueSansPro-Bold";
}
.v-application p,
body p {
  line-height: 1.5;
}
.v-application ul,
.v-application ol,
body ul,
body ol {
  line-height: 1.5;
}
.newLinwHeight {
  line-height: 1.2 !important ;
}
@media only screen and (max-width: 600px) {
  .heading-title-new {
    font-size: 16px !important;
  }
  .withoutBorder {
    border-right: 0px dotted !important;
  }
}
</style>
